// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"79cee50a","841":"bbf43c0e"}[chunkId] + ".chunk.js";
};